import { useTranslation } from "react-i18next";
import { ConfirmModal } from "./ConfirmModal";

export function OptInModal() {
  const { t } = useTranslation();

  const contentProps = {
    title: t("searchCard.modals.optInRequired"),
    description: t("searchCard.modals.optInRequiredQuestion"),
  };
  return <ConfirmModal {...contentProps} />;
}
